/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AdminSortField} from '../models/AdminSortField';
import type {AdminUserPage} from '../models/AdminUserPage';
import type {Error} from '../models/Error';
import type {SortDirection} from '../models/SortDirection';

export interface GetProfileAdmins$Request {
    profileId: number;
    pageNumber: number;
    pageSize: number;
    sortField?: AdminSortField;
    sortDirection?: SortDirection;
    searchByEmail?: string;
}

export interface GetProfileAdmins$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProfileAdminsRequest = createAction<PayloadData<void, GetProfileAdmins$Request>>('GET_PROFILE_ADMINS__GET_PROFILE_ADMINS__REQUEST');
export const getProfileAdminsSuccess = createAction<PayloadData<AdminUserPage, GetProfileAdmins$Request>>('GET_PROFILE_ADMINS__GET_PROFILE_ADMINS__SUCCESS');
export const getProfileAdminsFailure = createAction<PayloadData<Error, GetProfileAdmins$Request, true>>('GET_PROFILE_ADMINS__GET_PROFILE_ADMINS__FAILURE');

export const getProfileAdminsActions = [
    getProfileAdminsRequest,
    getProfileAdminsSuccess,
    getProfileAdminsFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {AdminSortField} [meta.sortField]
 * @param {SortDirection} [meta.sortDirection]
 * @param {string} [meta.searchByEmail]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProfileAdmins = (meta: GetProfileAdmins$Request, config?: GetProfileAdmins$Config) => {
    const TRANSPORT_GET_PARAMS = {
        sortField: meta.sortField,
        sortDirection: meta.sortDirection,
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        searchByEmail: meta.searchByEmail,
    };
    return {
        CALL_API: {
            types: getProfileAdminsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/profiles/${meta.profileId}/admins`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

